module.exports = __webpack_public_path__ + "img/discount_bg.582bfdd7.png";